export const getRequestFormStyle = (_, { palette = {} }) => ({
  requestFormContainer: {
    '& .form-horizontal': {
      margin: 0,
      maxWidth: 784,
      border: 0,
      boxShadow: 'none',
      '& .form-group': {
        margin: '0px 0px 18px 0px',
        '& .root': {
          width: 'unset',
          margin: 0,
          padding: 0,
          '& .error': {
            color: '#a4262c',
          },
          '& > label': {
            padding: 0,
          },
          '& .title': {
            fontWeight: 'normal',
          },
          '& .details': {
            margin: '27px 0px 0px 0px',
            padding: 0,
            '& .col-sm-4': {
              padding: '0px 0px 0px 1px',
              width: '50%',
              '& .appeal-column-title': {
                fontSize: 18,
                lineHeight: '24px',
                fontWeight: 'normal',
              },
              '& .reasons > ul': {
                margin: '1px 0px 0px 0px',
                paddingLeft: 0,
                listStyle: 'none',
                '& > li': {
                  marginTop: '10px',
                },
              },
            },
            '& .col-sm-8': {
              width: '50%',
              paddingLeft: 14,
              paddingRight: 0,
              '& .appeal-column-title': {
                fontSize: 14,
                lineHeight: '19px',
                fontWeight: 600,
              },
              '& .appeal-textarea': {
                marginTop: 7,
                padding: 8,
                fontSize: 14,
                lineHeight: '19px',
                border: `1px solid ${palette.neutralSecondary}`,
                borderRadius: '2px',
                background: '#FFFFFF',
                width: '100%',
              },
              '& .remaining-hint': {
                textAlign: 'right',
                marginTop: 3,
                marginBottom: 3,
                fontSize: 12,
                lineHeight: '16px',
              },
            },
          },
          '& .non-appeal-msg-panel': {
            margin: '11px 0px 0px 1px',
          },
        },
      },
    },
  },
});
